const getEnv = () => {
  const { hostname } = window.location;

  if (
    hostname ===
    "coach-webapp-dev-fe-ehhtfmhxg8hadtg7.westus2-01.azurewebsites.net"
  )
    return "local";
  if (hostname === "localhost") return "local";
  if (hostname.includes("apexplatform-fe") || hostname.includes("roarai.fit"))
    return "production";

  return "local";
};

const env = getEnv();

const configs = {
  local: {
    MSAL_POLICY: process.env.REACT_APP_MSAL_POLICY_LOCAL,
    MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID_LOCAL,
    MSAL_AUTHORITY: process.env.REACT_APP_MSAL_AUTHORITY_LOCAL,
    MSAL_AUTHORITY_AUTHORITIES:
      process.env.REACT_APP_MSAL_AUTHORITY_AUTHORITIES_LOCAL,
    MSAL_ISSUER: process.env.REACT_APP_MSAL_ISSUER_LOCAL,
    MSAL_REDIRECT_URI: process.env.REACT_APP_MSAL_REDIRECT_URI_LOCAL,
    POST_LOGOUT_REDIRECT_URI:
      process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI_LOCAL,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_LOCAL,
    ADMIN_API_BASE_URL: process.env.REACT_APP_ADMIN_API_BASE_URL_LOCAL,
    SCOPE_USER_READWRITE_ALL:
      process.env.REACT_APP_SCOPE_USER_READWRITE_ALL_LOCAL,
    MSAL_FORGOT_PASSWORD: process.env.REACT_APP_MSAL_FORGOT_PASSWORD_LOCAL,
    CUSTOME_TENANT_NAME: process.env.REACT_APP_TENANT_LOCAL,
    CUSTOME_POLICY_NAME: process.env.REACT_APP_MSAL_CUSTOME_POLICY_LOCAL,
  },
  development: {
    MSAL_POLICY: process.env.REACT_APP_MSAL_POLICY_DEV,
    MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID_DEV,
    MSAL_AUTHORITY: process.env.REACT_APP_MSAL_AUTHORITY_DEV,
    MSAL_AUTHORITY_AUTHORITIES:
      process.env.REACT_APP_MSAL_AUTHORITY_AUTHORITIES_DEV,
    MSAL_ISSUER: process.env.REACT_APP_MSAL_ISSUER_DEV,
    MSAL_REDIRECT_URI: process.env.REACT_APP_MSAL_REDIRECT_URI_DEV,
    POST_LOGOUT_REDIRECT_URI:
      process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI_DEV,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEV,
    ADMIN_API_BASE_URL: process.env.REACT_APP_ADMIN_API_BASE_URL_DEV,
    SCOPE_USER_READWRITE_ALL:
      process.env.REACT_APP_SCOPE_USER_READWRITE_ALL_DEV,
    MSAL_FORGOT_PASSWORD: process.env.REACT_APP_MSAL_FORGOT_PASSWORD_DEV,
    CUSTOME_TENANT_NAME: process.env.REACT_APP_TENANT_DEV,
    CUSTOME_POLICY_NAME: process.env.REACT_APP_MSAL_CUSTOME_POLICY_DEV,
  },
  production: {
    MSAL_POLICY: process.env.REACT_APP_MSAL_POLICY_PROD,
    MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID_PROD,
    MSAL_AUTHORITY: process.env.REACT_APP_MSAL_AUTHORITY_PROD,
    MSAL_AUTHORITY_AUTHORITIES:
      process.env.REACT_APP_MSAL_AUTHORITY_AUTHORITIES_PROD,
    MSAL_ISSUER: process.env.REACT_APP_MSAL_ISSUER_PROD,
    MSAL_REDIRECT_URI: process.env.REACT_APP_MSAL_REDIRECT_URI_PROD,
    POST_LOGOUT_REDIRECT_URI:
      process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI_PROD,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD,
    ADMIN_API_BASE_URL: process.env.REACT_APP_ADMIN_API_BASE_URL_PROD,
    SCOPE_USER_READWRITE_ALL:
      process.env.REACT_APP_SCOPE_USER_READWRITE_ALL_PROD,
    MSAL_FORGOT_PASSWORD: process.env.REACT_APP_MSAL_FORGOT_PASSWORD_PROD,
    CUSTOME_TENANT_NAME: process.env.REACT_APP_TENANT_PROD,
    CUSTOME_POLICY_NAME: process.env.REACT_APP_MSAL_CUSTOME_POLICY_PROD,
  },
};

const config = configs[env];
// Debugging logs
// console.log(`Running in ${env} mode`);

export default config;
